"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PaymentOptionsParser = void 0;
class PaymentOptionsParser {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  getPaymentOptionsIcons() {
    return {};
  }
}
exports.PaymentOptionsParser = PaymentOptionsParser;